import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";
import { colors } from "../constants/GlobalStyles";

const IconCarotArrowRight = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "33"}
    height={props.height || "32"}
    viewBox="0 0 33 32"
    fill="none"
    {...props}
  >
    <path
      d="M11.7433 22.12L17.8633 16L11.7433 9.88L13.6367 8L21.6367 16L13.6367 24L11.7433 22.12Z"
      fill={props.color || colors.secondaryAction.default}
    />
  </svg>
);

export default IconCarotArrowRight;
